import Alpine from 'alpinejs'
import closedUserGroupAccessCodeEmailForm from './closedUserGroupAccessCodeEmailForm'
import datePicker from './datePicker'
import experimentExposure from './experimentExposure'
import mortgageManager from './mortgageManager'
import numberOfGuestsSelect from './search/numberOfGuestsSelect'
import ownerplusDatePickerCell from './ownerplusDatePickerCell'
import ownerplusSearch from './ownerplusSearch'
import ownerplusWidget from './ownerplusWidget'
import ownerPointsLookup from './ownerPointsLookup'
import privacyConsent from './privacyConsent'
import recaptcha from './recaptcha'
import resortGallery from './resortGallery'
import resortPage from './resortPage'
import searchResults from './searchResults'
import signupPay from './signupPay'
import vacatiaplusLandingDestinations from './vacatiaplusLandingDestinations'
import vacatiaplusLandingDestinationsModalMap from './vacatiaplusLandingDestinationsModalMap'
import vacatiaplusLandingResortCardMapSvg from './vacatiaplusLandingResortCardMapSvg'

window.Alpine = Alpine

// window.x is deprecated. use Alpine.data() instead
window.x = {
  resortGallery,
  signupPay,
  numberOfGuestsSelect,
}

Alpine.data('closedUserGroupAccessCodeEmailForm', closedUserGroupAccessCodeEmailForm)
Alpine.data('datePicker', datePicker)
Alpine.data('experimentExposure', experimentExposure)
Alpine.data('mortgageManager', mortgageManager)
Alpine.data('ownerplusDatePickerCell', ownerplusDatePickerCell)
Alpine.data('ownerplusSearch', ownerplusSearch)
Alpine.data('ownerplusWidget', ownerplusWidget)
Alpine.data('ownerPointsLookup', ownerPointsLookup)
Alpine.data('privacyConsent', privacyConsent)
Alpine.data('recaptcha', recaptcha)
Alpine.data('resortPage', resortPage)
Alpine.data('searchResults', searchResults)
Alpine.data('vacatiaplusLandingDestinations', vacatiaplusLandingDestinations)
Alpine.data('vacatiaplusLandingDestinationsModalMap', vacatiaplusLandingDestinationsModalMap)
Alpine.data('vacatiaplusLandingResortCardMapSvg', vacatiaplusLandingResortCardMapSvg)
Alpine.start()
